import React, { useState, useContext, useEffect } from 'react';
import { useFormik } from 'formik';
import Button from '../../bootstrap/Button';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Label from '../../bootstrap/forms/Label';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';
// Database
import PrinterDB from '../../../database/wrappers/printer';
import ListProducts from '../../MyCustom/ListProducts';
import ProductDB from '../../../database/wrappers/product';
import { where } from 'firebase/firestore';
import { DefaultContext } from '../../../contexts/default';
import PreAlert from '../../../helpers/utils/preAlert';
import ListUsers from '../../MyCustom/ListUsers';
import MonitorsDB from '../../../database/wrappers/monitor';
import TotenDB from '../../../database/wrappers/toten';
import { ROLE } from '../../../types/roles';
import api from '../../../services/api';


const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Este campo é necessário';
  }

  if (!values.active) {
    errors.active = 'Você precisa escolher o status da Impressora';
  }

  return errors;
}

const ModalRegisterMonitors = ({ open, setIsOpen, setIsClose, monitorSelected }) => {

  const { establishment, store, onShowAlert } = useContext(DefaultContext)

  const [isLoading, setIsLoading] = useState(false);
  const [users, setusers] = useState([]);

  useEffect(() => {
    if (!open) return formik.resetForm();
    if (monitorSelected) {
      const { name, active, users } = monitorSelected;

      formik.setValues({
        name,
        active: active ? 'ativo' : 'inativo',
        users,
      });
    }
  }, [monitorSelected, open])

  useEffect(() => {
    if (!establishment || !store) return;
  
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await api.get('routes/users');
        const users = res.data.filter(user =>
          user.customClaims?.estabId === establishment.id &&
          user.customClaims?.storeId === store.id &&
          user.customClaims?.role === ROLE.CASHIER
        ).map((e) => ({
          ...e,
          id: e.uid,
          name: e.displayName,
          type: 'Usuário'
        })).sort((a, b) => a.name.localeCompare(b.name));
  
        const totens = await new TotenDB(establishment.id).getAll(
          where('active', '==', true),
          where('storeId', '==', store.id)
        );
  

        const totensFilter =  totens.map((t) => ({
          ...t,
          type: 'Totem'
        })).sort((a, b) => a.name.localeCompare(b.name));

        const all = [...users, ...totensFilter];
        setusers(all);
  
      } catch (error) {
        onShowAlert(PreAlert.error('Erro ao carregar usuários ou totens'));
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [establishment, store]);
  
  function randomNumberTerminal() {
    let min = 10000000;
    let max = 99999999;
    return parseInt(Math.random() * (+max - +min) + +min);
  }


  const formik = useFormik({
    initialValues: {
      name: '',
      active: '',
      users: [],
    },
    validate,
    onSubmit: async values => {
      const { name, active, users } = values;

      const data = {
        name,
        active: active === 'ativo',
        users,
      }

      const onSuccess = () => {
        onShowAlert(PreAlert.success('Registro cadastrado com sucesso'))
        setIsClose();
      }
      const onSuccessUpdate = () => {
        onShowAlert(PreAlert.success('Registro atualizado com sucesso'))
        setIsClose();
      }
      const onError = () => {
        onShowAlert(PreAlert.error('Falhou ao cadastrar o registro'))
      }

      setIsLoading(true);
      if (monitorSelected) {
        new MonitorsDB(establishment.id, store.id)
          .update(monitorSelected.id, data)
          .then(onSuccessUpdate)
          .catch(onError)
          .finally(() => setIsLoading(false))
      } else {
        new MonitorsDB(establishment.id, store.id)
          .create(data)
          .then(onSuccess)
          .catch(onError)
          .finally(() => setIsLoading(false))
      }
    },
  })

  return (
    <Modal
      id={'modal-register-printers'}
      titleId={'Cadastro de Monitor'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl' 
      isAnimation={true}
      onSubmit={formik.handleSubmit}
    >
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id="register-printer">{monitorSelected ? 'Atualização de Monitor' : 'Cadastro de Monitor'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <form noValidate onSubmit={formik.handleSubmit}>

          {/* Inputs */}
          <div className="row g-4">
            {/* Nome */}
            <FormGroup id="name" label="Nome" className='col-md-8'>
              <Input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
                isValid={formik.isValid}
                isTouched={formik.touched.name}
                invalidFeedback={formik.errors.name}
                validFeedback='Assim está bom!'
                placeholder='Eletrodomésticos, lâmpadas, etc...'
              />
            </FormGroup>
            {/* Status */}
            <FormGroup className='col-md-4'>
              <Label>Status</Label>
              <ChecksGroup
                isValid={formik.isValid}
                isTouched={formik.touched.active}
                invalidFeedback={formik.errors.active}
              >
                <Checks
                  type="radio"
                  id="active"
                  label="Ativo"
                  name="active"
                  value="ativo"
                  onChange={formik.handleChange}
                  checked={formik.values.active}
                  isInline
                />
                <Checks
                  type="radio"
                  id="active2"
                  label="Inativo"
                  name="active"
                  value="inativo"
                  onChange={formik.handleChange}
                  checked={formik.values.active}
                  isInline
                />
              </ChecksGroup>
            </FormGroup>
          </div>
          {/* List */}
          <ListUsers
            users={users}
            usersSelected={formik.values.users}
            onChange={formik.handleChange}
          />
          {/* Buttons */}
          <div className="row pt-4">
            <div className="col-md-4 offset-md-8">
              <div className='d-flex justify-content-evenly'>
                <Button
                  color="danger"
                  icon="cancel"
                  rounded={1}
                  onClick={setIsClose}
                  shadow="sm"
                  hoverShadow="sm"
                  size="sm"
                >
                  Cancelar
                </Button>
                {isLoading ? (
                  <Button
                    color="success"
                    rounded={1}
                    hoverShadow="sm"
                    shadow="sm"
                    size="sm"
                  >
                    <Spinner
                      color="light"
                      inButton
                      isGrow
                      isSmall
                      size={10}
                      tag="span"
                    >
                      Carregando...
                    </Spinner>
                    Carregando...
                  </Button>
                ) : (
                  <Button
                    isDisable={!formik.isValid && !!formik.submitCount}
                    type='submit'
                    color='success'
                    icon="check"
                    rounded={1}
                    hoverShadow="sm"
                    shadow="sm"
                    size="sm"
                  >
                    Confirmar
                  </Button>
                )}
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default ModalRegisterMonitors;